import type { ProtoCommandAgent } from "@/components/command-team-v2/prototype/types";
import { protoVisibilityToApi } from "@/types/visibility";

type ProtoAgentWriteValues = Partial<
    Omit<ProtoCommandAgent, "id" | "isActive" | "isDefault" | "createdAt">
>;

export function protoAgentPatchToApi(patch: ProtoAgentWriteValues): Record<string, unknown> {
    const data: Record<string, unknown> = {};

    if (patch.name !== undefined) data.name = patch.name;
    if (patch.role !== undefined) data.role = patch.role;
    if (patch.description !== undefined) data.description = patch.description;
    if (patch.persona !== undefined) data.persona = patch.persona;
    if (patch.restrictions !== undefined) data.restrictions = patch.restrictions;
    if (patch.visibility !== undefined) {
        data.visibility = protoVisibilityToApi(patch.visibility);
    }

    if (patch.llmConfig) {
        if (patch.llmConfig.provider !== undefined) {
            data.llm_provider = patch.llmConfig.provider;
        }
        if (patch.llmConfig.model !== undefined) data.llm_model = patch.llmConfig.model;
        if (patch.llmConfig.temperature !== undefined) {
            data.llm_temperature = patch.llmConfig.temperature;
        }
        if (patch.llmConfig.maxTokens !== undefined) {
            data.llm_max_tokens = patch.llmConfig.maxTokens;
        }
        if (patch.llmConfig.timeoutSec !== undefined) {
            data.llm_timeout = patch.llmConfig.timeoutSec;
        }
    }

    return data;
}

export function protoAgentValuesToCreatePayload(values: ProtoAgentWriteValues) {
    const llmPatch = protoAgentPatchToApi(values);

    return {
        name: values.name?.trim() ?? "",
        role: values.role?.trim() ?? "",
        description: values.description?.trim() || null,
        persona: values.persona?.trim() ?? "",
        restrictions: values.restrictions?.trim() || null,
        visibility: values.visibility
            ? protoVisibilityToApi(values.visibility)
            : "PERSONAL",
        ...(llmPatch.llm_model !== undefined
            ? {
                  llm_provider: llmPatch.llm_provider,
                  llm_model: llmPatch.llm_model,
                  llm_temperature: llmPatch.llm_temperature,
                  llm_max_tokens: llmPatch.llm_max_tokens,
                  llm_timeout: llmPatch.llm_timeout,
              }
            : {}),
    };
}
